import { TypeAnnualReportTableWithoutUnresolvableLinksResponse } from 'contentful-types'
import { withContentful } from '../../../renderer/contentful/withContentful'
import AnnualReportTable, { AnnualReportTableProps } from './AnnualReportTable'

const ContentfulAnnualReportTable = withContentful<
  TypeAnnualReportTableWithoutUnresolvableLinksResponse['fields'],
  AnnualReportTableProps
>(AnnualReportTable, {
  csv: (props) => props.fields?.csv?.fields?.file?.url,
  rowHeadingColumnWidth: (props) => {
    return {
      xs: props.fields?.xsRowHeadingColumnWidth as number,
      sm: props.fields?.smRowHeadingColumnWidth as number,
      md: props.fields?.mdRowHeadingColumnWidth as number,
      lg: props.fields?.lgRowHeadingColumnWidth as number,
      xl: props.fields?.xlRowHeadingColumnWidth as number,
    }
  },
  secondRowColumnWidth: (props) => {
    return {
      xs: props.fields?.xsSecondRowColumnWidth as number,
      sm: props.fields?.smSecondRowColumnWidth as number,
      md: props.fields?.mdSecondRowColumnWidth as number,
      lg: props.fields?.lgSecondRowColumnWidth as number,
      xl: props.fields?.xlSecondRowColumnWidth as number,
    }
  },
  remainingRowColumnsWidth: (props) => {
    return {
      xs: props.fields?.xsRemainingRowColumnsWidth as number,
      sm: props.fields?.smRemainingRowColumnsWidth as number,
      md: props.fields?.mdRemainingRowColumnsWidth as number,
      lg: props.fields?.lgRemainingRowColumnsWidth as number,
      xl: props.fields?.xlRemainingRowColumnsWidth as number,
    }
  },
})

export default ContentfulAnnualReportTable
